import LayoutRegisterPageComponent from "src/components/user/layout-register-page-component";
import RegisterConatiner from "src/containers/user/register-container/register-container";

function RegisterPage() {
  return (
    <LayoutRegisterPageComponent>
      <RegisterConatiner />
    </LayoutRegisterPageComponent>
  );
}

export default RegisterPage;
